<template>
  <span v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card data-testid="company-counts-page">
      <!-- pt-3 обязателен: без верхнего padding отрицательный margin первого <v-row>
           (у Vuetify .row margin: -12px) схлопывается наружу через v-sheet и v-card,
           поднимая всю карточку на 12px вверх — она наезжала на баннер о балансе. -->
      <v-sheet :min-height="toolbar_height" elevation="1" :color="$vuetify.theme.dark ? '' : 'white'"
        class="mb-3 start-tour-company-counts-1 px-3 pt-3 pb-5">
        <v-row>
          <v-col v-if="company && company.multicurrency_cashboxes" cols="12">
            <v-select v-model="selected_cashbox" multiple hide-details :items="company_cashboxes"
              :label="$t('companies.select_cashbox')"
              :item-text="item => `${item.name}. ${$t('companies.cashbox_cash')}: ${item.cash}${findCurrencySymbol(item.currency_id)}, ${$t('companies.cashbox_cashless')}: ${item.cashless}${findCurrencySymbol(item.currency_id)}`"
              item-value="id"></v-select>
          </v-col>
          <v-col v-else cols="12">
            <v-row>
              <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="d-flex justify-center">
                <v-text-field :value="company.cash" :label="$t('counts.cash')" hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="d-flex justify-center">
                <v-text-field :value="company.cashless" :label="$t('counts.entity')" hide-details
                  readonly></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="py-0">
                <v-menu v-model="start_date_menu" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="start_date_format" :label="$t('custom.start_period')" readonly hide-details
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="start_date" :locale="$i18n.locale" @input="start_date_menu = false"
                    first-day-of-week="1"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="py-0">
                <v-menu v-model="end_date_menu" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="end_date_format" :label="$t('custom.end_period')" readonly hide-details
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="end_date" :locale="$i18n.locale" @input="end_date_menu = false"
                    first-day-of-week="1"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pb-0">
            <v-row>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="d-flex align-center justify-center pb-0">
                <v-row>
                  <v-col cols="12" :lg="filter_cols.group" :md="filter_cols.group" sm="12" xs="12" class="py-0">
                    <v-select v-model="selected_group" clearable hide-details :items="group_filter_items"
                      :label="$t('counts.groups')" item-text="text" item-value="value"></v-select>
                  </v-col>
                  <v-col v-if="showSubcategoryFilter" cols="12" :lg="filter_cols.subcategory" :md="filter_cols.subcategory" sm="12" xs="12" class="py-0">
                    <v-select v-model="selected_subcategory_filter" clearable hide-details :items="subcategory_filter_items"
                      :label="$t('counts.subcategory')" item-text="text" item-value="value"
                      data-testid="counts-filter-subcategory"></v-select>
                  </v-col>
                  <v-col cols="12" :lg="filter_cols.type" :md="filter_cols.type" sm="12" xs="12" class="py-0">
                    <v-select v-model="selected_type" clearable hide-details :items="counts_types"
                      :label="$t('counts.types')" item-text="text" item-value="value"></v-select>
                  </v-col>
                  <v-col cols="12" :lg="filter_cols.worker" :md="filter_cols.worker" sm="12" xs="12" class="py-0">
                    <v-select v-model="selected_worker" clearable hide-details :items="workers_list"
                      :label="$t('custom.creator')" item-text="name" item-value="id"></v-select>
                  </v-col>
                  <v-col cols="12" :lg="filter_cols.search" :md="filter_cols.search" sm="12" xs="12" class="py-0">
                    <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line
                      clearable hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="mt-5">
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="d-flex justify-md-end justify-center">
                    <v-btn small color="success" to="/counts/new">{{ $t("counts.add_count") }}
                      <v-icon class="ml-2"> mdi-plus-circle-outline </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="d-flex justify-md-start justify-center">
                    <v-btn v-if="checkAdmin()" small class="mx-1" color="info" @click="showOperationPanel = true">
                      {{ $t("counts.kass_operations") }}
                      <v-icon class="ml-2"> mdi-cash-register </v-icon>
                    </v-btn>
                    <v-icon v-if="(isAdminPlus)" @click="toXlsx()"
                      style="cursor: pointer" color="success">
                      mdi-file-excel-outline
                    </v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
      <v-data-table :headers="company && company.multicurrency_cashboxes ? headers_with_currency : headers"
        :items="filtered_counts" :search="search" :custom-filter="customSearch" :loading="isLoading" :loading-text="$t('custom.loading_table')"
        :items-per-page="20" :dense="isMobile" v-resize="checkMobile" mobile-breakpoint="100" :sort-by="['created_at']"
        :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([20, 50, 100, -1])">
        <template slot="item" slot-scope="props">
          <tr :class="checkCountState(props.item)">
            <!-- FT-184 REQ-16: метка «через агента» — из ответа company_counts_v2 (agent_marks), без своего запроса -->
            <td class="text-center">
              {{ props.item.id }}
              <agent-marker record-type="Count" :record-id="props.item.id" />
            </td>
            <td class="text-center" nowrap>
              {{ formatCreatedAt(props.item.created_at) }}
              <div class="caption" v-if="props.item.old_created_at">
                {{ formatCreatedAt(props.item.old_created_at) }}
              </div>
            </td>
            <td class="text-center">
              <!-- {{ setWorker(props.item.user_id) }} -->
              {{ props.item.user?.name }}
            </td>
            <td class="text-center" nowrap>
              <v-btn icon @click="editCount(props.item)"
                :disabled="isLoadingEditCount && selected_count_id == props.item.id"
                :loading="isLoadingEditCount && selected_count_id == props.item.id">
                <v-icon>
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
              <!-- Отмена только у ПРОВЕДЁННЫХ платежей. У непроведённого разворачивать
                   нечего: деньги он не двигал (движение делает проведение), а отмена
                   плодила корректирующую строку, которая ничего не корректирует, — та
                   сама оставалась отменяемой и тянула повторное применение движения.
                   Ошибочный отложенный платёж правится редактированием: PATCH меняет
                   сумму, пока строка не проведена. -->
              <v-btn icon @click="cancelCount(props.item)" data-testid="count-cancel" v-if="
                checkAdmin &&
                props.item.completed &&
                !props.item.canceled &&
                props.item.group != 'Внутренние переводы' &&
                !props.item.stripe &&
                !props.item.yandex_pay
              " :disabled="isLoadingcancelCount && selected_count_id == props.item.id"
                :loading="isLoadingcancelCount && selected_count_id == props.item.id" color="warning" v-tooltip="{
                  content: $t('tooltips.cancel_count'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">
                <v-icon>
                  mdi-credit-card-refund-outline
                </v-icon>
              </v-btn>
            </td>
            <td class="text-center">
              {{ countCategoryLabel(props.item) }}
            </td>
            <td v-if="company && company.multicurrency_cashboxes" class="text-center">
              {{ findCashboxName(props.item.company_cashbox_id) }}
            </td>
            <td class="text-center">{{ props.item.description }}</td>
            <td v-if="company && company.multicurrency_cashboxes" class="text-center">
              <span :title="$t('counts.last_balance') + ': ' + props.item.last_balance" style="cursor: pointer;"
                @click="showLastBalanceDialog = true, last_balance = props.item.last_balance">
                {{ props.item.sum }}{{ findCurrencySymbol(props.item.currency_id) }}
              </span>
              <span v-if="props.item.rate && (props.item.rate != 1 && props.item.rate != 0) && props.item.rate != null">
                ({{ props.item.rated_sum }})
              </span>
            </td>
            <td v-else class="text-center">
              <span :title="$t('counts.last_balance') + ': ' + props.item.last_balance" style="cursor: pointer;"
                @click="showLastBalanceDialog = true, last_balance = props.item.last_balance">
                {{ props.item.sum }}{{ currency }}
              </span>
            </td>
            <td class="text-center" v-if="props.item.operation">
              <v-icon class="text-center" style="color: green">
                mdi-plus-circle-outline
              </v-icon>
            </td>
            <td class="text-center" v-if="!props.item.operation">
              <v-icon class="text-center" style="color: tomato">
                mdi-minus-circle-outline
              </v-icon>
            </td>
            <td class="text-center">
              <v-icon v-if="props.item.cash" class="text-center" color="success" v-tooltip="{
                content: $t('tooltips.cash_count'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }">
                mdi-cash
              </v-icon>
              <v-icon v-else-if="props.item.cashless" class="text-center" color="warning" v-tooltip="{
                content: $t('tooltips.terminal_count'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }">
                mdi-contactless-payment-circle-outline
              </v-icon>
              <v-icon v-else-if="props.item.entity" class="text-center" color="secondery" v-tooltip="{
                content: $t('tooltips.entity_count'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }">
                mdi-bank
              </v-icon>
              <v-icon v-else-if="props.item.cash_card" class="text-center" color="info" v-tooltip="{
                content: $t('tooltips.card_to_card'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }">
                mdi-credit-card-check-outline
              </v-icon>
              <!-- Прочерк — хвост цепочки v-if по четырём денежным типам, он означает «тип не
                   указан». У платежа с баланса клиента все четыре флага пустые, поэтому
                   прочерк печатался ВСЕГДА и вставал рядом с иконкой человечка, хотя тип
                   как раз известен. Молчим, когда тип показывает следующая иконка. -->
              <span v-else-if="!props.item.client_balance">-</span>
              <v-icon @click="toClientCard(props.item)" :style="clientCardCursor(props.item)" v-if="props.item.client_balance" class="text-center" color="error" v-tooltip="{
                content: $t('money.client_balance'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }">
                mdi-account-arrow-right
              </v-icon>
              <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                mdi-alpha-y-circle
              </v-icon>
              <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                mdi-alpha-s-circle-outline
              </v-icon>
            </td>
            <td class="text-center">
              <router-link v-if="props.item.contractor_id" :to="{ path: `/contractors/${props.item.contractor_id}` }">
                {{ findContractorName(props.item.contractor_id) }}
              </router-link>
              <span v-else> - </span>
            </td>
            <td class="text-center" nowrap v-if="
              props.item.booking_id &&
              props.item.car_id &&
              props.item.car_code
            ">
              <p>
                {{ $t("bookings.booking") }}:
                <router-link :to="{ path: `/bookings/${props.item.booking_id}` }">
                  {{ props.item.booking_id }}
                </router-link>
              </p>
              <p>
                {{ $t("custom.car") }}:
                <router-link :to="{ path: `/cars/${props.item.car_id}` }">
                  {{ props.item.car_code }}
                </router-link>
              </p>
            </td>
            <td class="text-center" v-else-if="props.item.car_id && props.item.car_code">
              <router-link :to="{ path: `/cars/${props.item.car_id}` }">{{
                props.item.car_code
                }}</router-link>
            </td>
            <td class="text-center" v-else-if="props.item.yandex_pay || props.item.stripe">
              <router-link :to="{ path: `/clients/${props.item.client_id}` }">
                  {{ $t("bookings.client") }}
                </router-link>
            </td>
            <td class="text-center" v-else-if="props.item.source">
              {{ translateCountSource(props.item.source) }}
            </td>
            <td class="text-center" v-else-if="props.item.investor_id">
              <router-link :to="{ path: `/investors/${props.item.investor_id}` }">
                {{ $t("employers.partner") }} {{ $t("custom.number") }}{{ props.item.investor_id }}
              </router-link>
            </td>
            <td class="text-center" v-else-if="props.item.debt_id">
              {{ $t("debts.debt") }} {{ $t("custom.number") }}{{ props.item.debt_id }}
            </td>
            <td class="text-center" v-else-if="props.item.agent_id">
              {{ $t("agents.agent") }} {{ $t("custom.number") }}
              <router-link :to="{ path: `/agent_card/${props.item.agent_id}` }">
                {{ props.item.agent_id }}
              </router-link>
            </td>
            <td class="text-center" v-else>-</td>
            <td class="text-center">
              <v-icon v-if="props.item.completed" color="success" v-tooltip="{
                content: $t('counts.completed'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }" @click="completedTooltipDialog(props.item)">
                mdi-check-circle-outline
              </v-icon>
              <v-icon v-else color="error" v-tooltip="{
                content: $t('counts.not_completed'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }" @click="processedCount(props.item)">
                mdi-alert-circle-outline
              </v-icon>
            </td>
            <td class="text-center">
              <v-menu offset-y v-if="props.item.check == null">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-2" v-tooltip="{
                    content: $t('tooltips.some_invoice'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="secondary">
                    mdi-map-marker-question-outline
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in countStates" :key="index"
                    @click="updateСountCheck(props.item.id, state.state)">
                    <v-list-item-title>
                      {{ state.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.check == true">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-2" v-tooltip="{
                    content: $t('tooltips.trust_invoice'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="success">
                    mdi-checkbox-outline
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in countStates" :key="index"
                    @click="updateСountCheck(props.item.id, state.state)">
                    <v-list-item-title>
                      {{ state.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.check == false">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-2" v-tooltip="{
                    content: $t('tooltips.bad_invoice'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="error">
                    mdi-bookmark-remove-outline
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in countStates" :key="index"
                    @click="updateСountCheck(props.item.id, state.state)">
                    <v-list-item-title>
                      {{ state.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          {{ $t("custom.no_data_in_table") }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
          {{ $t("tables.no_search_result", { msg: search }) }}
        </v-alert>
      </v-data-table>
      <v-divider></v-divider>
      <v-expansion-panels v-if="filtered_counts.length > 0">
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t("custom.summary") }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-simple-table v-if="filtered_counts.length > 0 && company && !company.multicurrency_cashboxes" dense
              class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr v-for="group in viewed_groups" :key="group">
                    <th>{{ translateCategory(group) }}</th>
                    <td class="">{{ totalSumByGroup(group) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table v-if="filtered_counts.length > 0 && company && company.multicurrency_cashboxes" dense
              class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr v-for="group in viewed_groups" :key="group">
                    <th>{{ translateCategory(group) }}</th>
                    <td class="">{{ totalSumRatedByGroup(group) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <v-dialog v-model="editDialog" :retain-focus="false" persistent :fullscreen="isMobile ? true : false"
      max-width="1000px">
      <v-card :loading="isLoadingSaveCount">
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("custom.editing") }}</span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="3" md="3" v-if="user_role == 'superadmin'">
              <!-- positionFixed: поповер v-calendar рендерится внутри .v-dialog (overflow-y: auto)
                   и с position: absolute обрезался по низу диалога — выбор времени уходил
                   во внутренний скролл, на macOS без видимой полосы прокрутки. -->
              <vc-date-picker v-model="edited_created_at" mode="dateTime" :timezone="companyTimeZone"
                :popover="{ positionFixed: true }"
                :model-config="calendarConfig" :attributes="calendar_attributes" is24hr title-position="left"
                class="flex d-flex md12 p-0" :locale="$i18n.locale" :is-dark="$vuetify.theme.dark">
                <template v-slot="{
                  inputValue,
                  inputEvents,
                  isDragging,
                  showPopover,
                }">
                  <v-flex md12 :class="isMobile ? '' : 'd-flex'">
                    <v-text-field @click="showPopover" :class="isDragging
                      ? 'text-gray-600 mt-0 p-0'
                      : 'text-gray-900 mt-0 p-0'
                      " :value="inputValue" v-on="inputEvents" :label="$t('custom.created_at')" readonly
                      hide-details></v-text-field>
                  </v-flex>
                </template>
              </vc-date-picker>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-text-field :readonly="editedCount.completed == true" v-model.number="editedCount.sum"
                :label="$t('custom.amount')"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-combobox v-model="selected_count" :disabled="editCategoryLocked"
                    :hint="editCategoryLockHint" persistent-hint item-text="text" item-value="value" :items="editGroupItems"
                :label="$t('custom.select_group')" @change="onEditCategoryChange"></v-combobox>
            </v-col>
            <v-col cols="12" sm="3" md="3" v-if="showEditSubcategory">
              <v-autocomplete v-model="selected_subcategory" :items="editSubcategoryOptions" item-text="value"
                item-value="id" :label="$t('counts.subcategory')" clearable :disabled="editSubcategoryLocked"
                data-testid="edit-count-subcategory" @input="onEditSubcategoryInput"></v-autocomplete>
            </v-col>
            <!-- С подкатегорией первый ряд занят (дата, сумма, статья, подкатегория) —
                 автомобиль уходит во второй ряд к контрагенту; без неё раскладка прежняя. -->
            <v-col cols="12" :sm="showEditSubcategory ? 4 : 3" :md="showEditSubcategory ? 4 : 3">
              <v-text-field v-if="!showCarSearch" :label="$t('custom.car_long', { msg: object_name_for_label })" :placeholder="$t('custom.car_long', { msg: object_name_for_label })"
                :value="editedCount.car_code" @click="showCarSearch = true"></v-text-field>
              <v-autocomplete v-if="showCarSearch" v-model="selected_car" item-text="code" item-value="id"
                :loading="isLoadingCars" :search-input.sync="searchCar" text hide-no-data hide-details
                :label="$t('custom.select_car')" :items="cars" return-object>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" :sm="showEditSubcategory ? 8 : 12" :md="showEditSubcategory ? 8 : 12">
              <v-autocomplete v-model="editedCount.contractor_id" item-text="short_name" item-value="id" clearable
                :items="contractors" :label="$t('contractors.select_contractor')" hide-no-data
                hide-details></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-textarea v-model="editedCount.description" :label="$t('counts.count_description')"
                :placeholder="$t('counts.count_description_plc')" rows="1" auto-grow></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-10">
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false, selected_count_id = null">{{
            $t("custom.close")
          }}</v-btn>
          <v-btn color="success" @click="saveCount()" :loading="isLoadingSaveCount">{{
            $t("custom.save")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showOperationPanel" :retain-focus="false" :fullscreen="isMobile ? true : false" max-width="600px"
      :style="isMobile ? 'padding: 5px !important;' : ''">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("counts.kass_operations") }}</span>
        </v-card-title>
        <v-card-text :style="isMobile ? 'padding: 15px !important;' : ''">
          <v-flex v-if="company && company.multicurrency_cashboxes" md12 class="">
            <v-flex md12 class="d-flex"
              v-if="company_cashboxes_without_all && company_cashboxes_without_all.length > 1">
              <v-select v-model="selected_cashbox_in_operations" hide-details :items="company_cashboxes_without_all"
                :label="$t('companies.select_cashbox')"
                :item-text="item => `${item.name}. ${$t('companies.cashbox_cash')}: ${item.cash}, ${$t('companies.cashbox_cashless')}: ${item.cashless}`"
                item-value="id" return-object></v-select>
            </v-flex>
            <v-flex md12 class="d-flex" v-else>
              <v-text-field v-model="selected_cashbox_in_operations.cash" :label="$t('counts.cash')" hide-details
                readonly></v-text-field>
              <v-text-field v-model="selected_cashbox_in_operations.cashless" :label="$t('counts.entity')" class="mx-2"
                hide-details readonly></v-text-field>
            </v-flex>
            <v-flex md12 class="d-flex mt-3">
              <v-text-field :disabled="give_cash > 0" v-model.number="get_cash" hide-details
                :label="$t('counts.get_kass')"></v-text-field>
              <v-text-field :disabled="get_cash > 0" v-model.number="give_cash" hide-details class="mx-2"
                :label="$t('counts.give_kass')"></v-text-field>
            </v-flex>
            <v-flex md12>
              <v-flex md12 class="d-flex justify-between-center align-center mt-2">
                <v-flex class="mt-0">
                  <v-radio-group v-model="cash_or_cashless" hide-details class="mt-0 align-top" row>
                    <v-radio :label="$t('counts.cashless')" v-tooltip="{
                      content: $t('tooltips.entity_payment'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 300,
                      },
                    }" :value="true"></v-radio>
                    <v-radio :label="$t('counts.cash_2')" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex class="mt-0">
                  <v-radio-group v-model="internal_external" hide-details class="mt-0 align-top" row>
                    <v-radio v-if="checkSuperAdmin()" :label="$t('counts.external')" :value="true"></v-radio>
                    <v-radio :label="$t('counts.internal')" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-flex>
              <v-flex md12>
                <v-textarea v-model="count_description" rows="2" clearable
                  :label="$t('counts.description')"></v-textarea>
              </v-flex>
            </v-flex>
          </v-flex>
          <v-flex v-else md12 class="">
            <v-flex md12 class="d-flex">
              <v-text-field :value="company.cash" :label="$t('counts.cash')" hide-details readonly></v-text-field>
              <v-text-field :value="company.cashless" :label="$t('counts.entity')" class="mx-2" hide-details
                readonly></v-text-field>
            </v-flex>
            <v-flex md12 class="d-flex mt-3">
              <v-text-field :disabled="give_cash > 0" v-model.number="get_cash" hide-details
                :label="$t('counts.get_kass')"></v-text-field>
              <v-text-field :disabled="get_cash > 0" v-model.number="give_cash" hide-details class="mx-2"
                :label="$t('counts.give_kass')"></v-text-field>
            </v-flex>
            <v-flex md12>
              <v-flex md12 class="d-flex justify-between-center align-center mt-2">
                <v-flex class="mt-0">
                  <v-radio-group v-model="cash_or_cashless" hide-details class="mt-0 align-top" row>
                    <v-radio :label="$t('counts.cashless')" v-tooltip="{
                      content: $t('tooltips.entity_payment'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 300,
                      },
                    }" :value="true"></v-radio>
                    <v-radio :label="$t('counts.cash_2')" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex class="mt-0">
                  <v-radio-group v-model="internal_external" hide-details class="mt-0 align-top" row>
                    <v-radio v-if="checkSuperAdmin()" :label="$t('counts.external')" :value="true"></v-radio>
                    <v-radio :label="$t('counts.internal')" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-flex>
              <v-flex md12>
                <v-textarea v-model="count_description" rows="2" clearable
                  :label="$t('counts.description')"></v-textarea>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showOperationPanel = false">{{
            $t("custom.close")
          }}</v-btn>
          <v-btn color="success" @click="saveOperation()">{{
            $t("custom.save")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showProcessedInfoDialog" :retain-focus="false" persistent max-width="500px">
      <v-card>
        <v-card-title v-if="workers && workers.length > 0">
          {{ `${$t('counts.completed')}: ${formatCompletedAt(
            editedCount.completed_at
          )}, ${findWorkersName([editedCount.completed_by])}` }}
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showProcessedInfoDialog = false, editedCount = {}">
            {{ $t("custom.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showLastBalanceDialog" :retain-focus="false" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showLastBalanceDialog = false, last_balance = 0">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>{{ $t("counts.last_balance") }}: {{ last_balance }}</v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import {
  NO_SUBCATEGORY,
  filterBySubcategory,
  hasSubcategoryTree,
  subcategoriesFor,
  translateCountCategory,
} from "@/utils/countCategory";
import { paymentDateForSave } from "@/utils/paymentDate";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
// moment.locale("ru");
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { saveAs } from "file-saver";
import xlsx from "json-as-xlsx";
import clientCardLinkMixin from "@/mixins/clientCardLinkMixin";
import rentalObjectMixin from "@/mixins/rentalObjectMixin";
import countEditCategoryMixin from "@/mixins/countEditCategoryMixin";
import countCategoryLabelMixin from "@/mixins/countCategoryLabelMixin";
import AgentMarker from "@/components/agents/AgentMarker.vue";
import agentMarkerLoader from "@/components/agents/agentMarkerLoader";

export default {
  components: { AgentMarker },
  mixins: [clientCardLinkMixin, rentalObjectMixin, countEditCategoryMixin, countCategoryLabelMixin],
  pullToRefresh: true,
  data() {
    return {
      counts: [],
      cars: [],
      search: "",
      workers: [],
      contractors: [],
      account: {
        cash: 0,
        cashless: 0,
      },
      editedCount: [],
      // Дата платежа в пикере правки и пришедшая с сервера — сравниваются при сохранении
      // (@/utils/paymentDate).
      edited_created_at: null,
      original_created_at: null,
      selected_car: null,
      selected_count: null,
      get_cash: 0,
      give_cash: 0,
      money_track: false,
      cash_or_cashless: false,
      internal_external: false,
      count_description: "",
      showProcessedInfoDialog: false,
      showLastBalanceDialog: false,
      last_balance: 0,
      showCarSearch: false,
      isLoadingCars: false,
      searchCar: null,
      start_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      start_date_format: moment().subtract(1, "month").format("DD-MM-YYYY"),
      end_date_format: moment().format("DD-MM-YYYY"),
      start_date_menu: false,
      end_date_menu: false,
      countStates: [
        { state: true, text: this.$t("counts.checked") },
        { state: false, text: this.$t("counts.not_approved") },
        { state: null, text: this.$t("counts.not_finded") },
      ],
      selected_group: null,
      // FT-192: фильтр подкатегории выбранной статьи (id или NO_SUBCATEGORY)
      selected_subcategory_filter: null,
      filtered_counts: [],
      counts_types: [
        { text: this.$t("money.cash"), value: "cash" },
        { text: this.$t("money.terminal"), value: "cashless" },
        { text: this.$t("money.card_to_card"), value: "cash_card" },
        { text: this.$t("money.from_entity"), value: "entity" },
        { text: this.$t("money.client_balance"), value: "client_balance" },
      ],
      selected_type: null,
      selected_worker: null,
      headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.creator"), value: "user_id", align: "center" },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
        { text: this.$t("counts.groups"), align: "center" },
        {
          text: this.$t("custom.description"),
          sortable: false,
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.operation"),
          value: "operation",
          align: "center",
        },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
        {
          text: this.$t("contractors.contractor"),
          value: "contractor_id",
          align: "center",
        },
        { text: this.$t("custom.source"), sortable: false, align: "center" },
        { text: this.$t("counts.completed"), value: "completed", align: "center" },
        { text: this.$t("custom.state"), value: "check", align: "center" },
      ],
      headers_with_currency: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.creator"), value: "user_id", align: "center" },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
        { text: this.$t("counts.groups"), align: "center" },
        { text: this.$t("companies.count"), value: "company_cashbox_id", align: "center" },
        {
          text: this.$t("custom.description"),
          sortable: false,
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.operation"),
          value: "operation",
          align: "center",
        },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
        {
          text: this.$t("contractors.contractor"),
          value: "contractor_id",
          align: "center",
        },
        { text: this.$t("custom.source"), sortable: false, align: "center" },
        { text: this.$t("counts.completed"), value: "completed", align: "center" },
        { text: this.$t("custom.state"), value: "check", align: "center" },
      ],
      // Date, а не строка «DD-MM-YYYY H:mm»: строка без смещения теряла пояс по дороге в API.
      calendarConfig: {
        type: "date",
      },
      calendar_attributes: [
        {
          key: "today",
          highlight: {
            color: "red",
            fillMode: "outline",
          },
          dates: new Date(),
        },
      ],
      selected_cashbox: [-1],
      selected_cashbox_in_operations: {
        cash: 0,
        cashless: 0,
      },
      pagination: { sortBy: "created_at", descending: true },
      showOperationPanel: false,
      showKassOperation: false,
      selected_count_id: null,
      editDialog: false,
      isLoading: true,
      isLoadingcancelCount: false,
      isLoadingEditCount: false,
      isLoadingSaveCount: false,
      isMobile: false,
      error: "",
    };
  },
  mounted() {
    let self = this;
  },
  created() {
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin) {
        this.getCounts();
        if (this.$route.params != {} && this.$route.params.query) {
          this.search = this.$route.params.query;
        }
      } else {
        this.goBack();
        this.$notify(this.$t("errors.not_permitted_title"), this.$t("errors.only_admins"), "warning", 5000);
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    searchCar(val) {
      // Items have already been loaded
      if (this.cars.length > 0) return;

      // Items have already been requested
      if (this.isLoadingCars) return;

      this.isLoadingCars = true;

      // Lazily load input items
      this.axios
        .get("/api/v1/cars", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.cars.push(element.attributes);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.cars_load"));
          console.log(error);
        })
        .finally(() => (this.isLoadingCars = false));
    },
    start_date() {
      if (this.start_date) {
        this.start_date_format = moment(this.start_date, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );
        if (this.start_date && this.end_date) {
          this.getCounts();
        }
      }
    },
    end_date() {
      if (this.end_date) {
        this.end_date_format = moment(this.end_date, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );

        this.getCounts();
      }
    },
    selected_group() {
      if (this.selected_group) {
        this.selected_type = null;
        this.selected_worker = null;
      }
      // Подкатегория принадлежит статье: другая статья — фильтр подкатегории сбрасывается.
      // Сброс сам перефильтрует список watcher'ом подкатегории — второй проход не нужен.
      if (this.selected_subcategory_filter !== null) {
        this.selected_subcategory_filter = null;
      } else {
        this.applyGroupFilters();
      }
      if (!this.selected_group) this.filtered_counts = this.counts;
    },
    // Сочетается с фильтром статьи: без выбранной статьи фильтра подкатегории нет
    selected_subcategory_filter() {
      this.applyGroupFilters();
    },
    selected_type() {
      if (this.selected_type) {
        this.selected_group = null;
        this.selected_worker = null;
        this.filtered_counts = this.counts.filter((count) => {
          if (this.selected_type == "cash") {
            return count.cash == true;
          } else if (this.selected_type == "cashless") {
            return count.cashless == true;
          } else if (this.selected_type == "cash_card") {
            return count.cash_card == true;
          } else if (this.selected_type == "entity") {
            return count.entity == true;
          } else if (this.selected_type == "client_balance") {
            return count.client_balance == true;
          }
        });
      } else {
        this.filtered_counts = this.counts;
      }
    },
    selected_cashbox() {
      if (this.selected_cashbox && this.selected_cashbox.length > 0 && this.selected_cashbox.includes(-1)) {
        this.filtered_counts = this.counts;
      } else if (this.selected_cashbox && this.selected_cashbox.length > 0) {
        this.filtered_counts = this.counts.filter((count) => {
          return this.selected_cashbox.includes(count.company_cashbox_id);
        });
      } else {
        this.filtered_counts = this.counts;
      }
    },
    selected_worker() {
      if (this.selected_worker) {
        this.selected_group = null;
        this.selected_type = null;
        this.filtered_counts = this.counts.filter((count) => {
          return count.user_id == this.selected_worker;
        });
      } else {
        this.filtered_counts = this.counts;
      }
    },
  },
  computed: {
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    company() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company;
      }
      return undefined;
    },
    // Пикер даты платежа показывает время филиала — как таблица (moment.parseZone ответа API).
    // Пояс, которого Intl не знает, уронил бы пикер — тогда пояс браузера, как раньше.
    companyTimeZone() {
      const timeZone = this.company && this.company.time_zone;
      if (!timeZone) return undefined;
      try {
        new Intl.DateTimeFormat("en-US", { timeZone });
        return timeZone;
      } catch (e) {
        return undefined;
      }
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
    exchange_rates() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.exchange_rates) {
        return this.$store.getters.getCompany.company.exchange_rates;
      } else {
        return [];
      }
    },
    company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes && this.$store.getters.getCompany.company.company_cashboxes.length > 0) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          cashboxes.push({
            id: cashbox.id,
            name: cashbox.name,
            cash: parseFloat(cashbox.cash).toFixed(2),
            cashless: parseFloat(cashbox.cashless).toFixed(2),
            currency_id: cashbox.currency_id,
          });
        });
        if (cashboxes.filter((cashbox) => cashbox.id == -1).length == 0) {
          cashboxes.push(
            {
              id: -1,
              name: this.$t("companies.all_cashboxes"),
              cash: 0,
              cashless: 0,
              currency_id: this.base_currency_id,
            },
          );
        }
        let cash_sum = 0;
        let cashless_sum = 0;
        cashboxes.forEach((cashbox) => {
          if (cashbox.id != -1) {
            if (cashbox.currency_id == this.base_currency_id) {
              cash_sum += parseFloat(cashbox.cash);
              cashless_sum += parseFloat(cashbox.cashless);
            } else {
              let cash_sum_in_base_currency = this.sumInBaseCurrency(cashbox.cash, cashbox.currency_id);
              let cashless_sum_in_base_currency = this.sumInBaseCurrency(cashbox.cashless, cashbox.currency_id);
              cash_sum += cash_sum_in_base_currency;
              cashless_sum += cashless_sum_in_base_currency;
            }
          }
        });
        // Округление итоговых сумм
        cash_sum = parseFloat(cash_sum.toFixed(2));
        cashless_sum = parseFloat(cashless_sum.toFixed(2));

        cashboxes.find((cashbox) => {
          if (cashbox.id == -1) {
            cashbox.cash = cash_sum;
            cashbox.cashless = cashless_sum;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    company_cashboxes_without_all() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          cashboxes.push({
            id: cashbox.id,
            name: cashbox.name,
            cash: cashbox.cash,
            cashless: cashbox.cashless,
            currency_id: cashbox.currency_id,
          });
        });
        let cash_sum = 0;
        let cashless_sum = 0;
        cashboxes.forEach((cashbox) => {
          if (cashbox.id != -1) {
            if (cashbox.currency_id == this.base_currency_id) {
              cash_sum += cashbox.cash;
              cashless_sum += cashbox.cashless;
            } else {
              let cash_sum_in_base_currency = this.sumInBaseCurrency(cashbox.cash, cashbox.currency_id);
              let cashless_sum_in_base_currency = this.sumInBaseCurrency(cashbox.cashless, cashbox.currency_id);
              cash_sum += cash_sum_in_base_currency;
              cashless_sum += cashless_sum_in_base_currency;
            }
          }
        });
        cashboxes.find((cashbox) => {
          if (cashbox.id == -1) {
            cashbox.cash = cash_sum;
            cashbox.cashless = cashless_sum;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    toolbar_height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 460
        case 'sm': return 460
        case 'md': return 230
        case 'lg': return 230
        case 'xl': return 230
      }
      return undefined;
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
    // Пункты фильтра статьи журнала: ВСЕ статьи компании — платежи есть и по скрытым,
    // и по системным. Нет дерева (филиал без строк статей) — запасной список
    // (источник — тот же, что у диалога правки: editCategoriesSource миксина).
    group_filter_items() {
      return this.editCategoriesSource
        .filter((category) => category && category.value)
        .map((category) => ({ text: this.translateCategory(category.value), value: category.value }));
    },
    // Поле подкатегории — только у статьи с деревом подкатегорий (как во вкладке настроек);
    // у «Залога», переводов, сервисных сборов и статей без кода подкатегорий не бывает
    // Ширины ряда фильтров (md+): с полем подкатегории в 12 колонок входят пять полей и «Поиск» не уезжает
    // на вторую строку; без него — прежние 3+3+3+3.
    filter_cols() {
      return this.showSubcategoryFilter
        ? { group: 3, subcategory: 2, type: 2, worker: 2, search: 3 }
        : { group: 3, subcategory: 3, type: 3, worker: 3, search: 3 };
    },
    showSubcategoryFilter() {
      const category = this.editCategoriesSource.find((item) => item && item.value === this.selected_group);
      return !!category && hasSubcategoryTree(category);
    },
    // Пункты фильтра подкатегории выбранной статьи: «Без подкатегории» и все её подкатегории
    // (скрытые тоже — платежи на них остались)
    subcategory_filter_items() {
      const category = this.editCategoriesSource.find((item) => item && item.value === this.selected_group);
      return [
        { text: this.$t("counts.no_subcategory"), value: NO_SUBCATEGORY },
        ...subcategoriesFor(category, { includeInactive: true }).map((sub) => ({ text: sub.value, value: sub.id })),
      ];
    },
    viewed_groups() {
      let unique_groups = new Set();
      this.filtered_counts.forEach(count => {
        unique_groups.add(count.group);
      });
      return Array.from(unique_groups);
    },
    workers_list() {
      return this.workers || [];
    },
  },
  methods: {
    // Баланс после внутреннего перевода — на экране до следующей загрузки. Компания в сторе
    // меняется новым объектом (не правкой объекта из геттера). Суммы — числами: toFixed(2)
    // даёт строку, и `cash += "5.00"` склеивал строки.
    // Ветка компании сейчас недостижима: selected_cashbox_in_operations — касса с id или
    // заглушка без id (undefined, не null). Ветка кассы правит кешированную computed-копию,
    // поэтому балансы на экране после операции не обновляются ни так, ни раньше.
    applyOperationToBalances() {
      const field = this.cash_or_cashless ? "cashless" : "cash";
      const amount = (value) => (value > 0 ? Number(value.toFixed(2)) : 0);
      const apply = (balance) => Number(balance) - amount(this.get_cash) + amount(this.give_cash);
      if (this.selected_cashbox_in_operations.id === null) {
        this.$store.commit("setCompany", {
          ...this.$store.getters.getCompany,
          company: { ...this.company, [field]: apply(this.company[field]) },
        });
      } else {
        // company_cashboxes — computed-копия касс, не объекты стора.
        const cashbox = this.company_cashboxes.find((item) => item.id == this.selected_cashbox_in_operations.id);
        if (cashbox) cashbox[field] = apply(cashbox[field]);
      }
    },
    customSearch(value, search, item) {
      if (!search) return true;
      
      const searchLower = search.toString().toLowerCase();
      
      // Стандартные поля для поиска
      const standardFields = [
        item.id?.toString(),
        item.description,
        item.sum?.toString(),
        item.user?.name,
        this.countCategoryLabel(item), // Переведённая группа с подкатегорией
        this.findContractorName(item.contractor_id), // Имя контрагента
        item.car_code, // Код машины
        item.booking_id?.toString(),
      ];
      
      // Поиск по источнику
      if (item.source) {
        standardFields.push(this.translateCountSource(item.source)); // Переведённый источник
        standardFields.push(item.source); // Оригинальный источник
      }
      
      // Поиск по кассе (для мультивалютных)
      if (item.company_cashbox_id) {
        standardFields.push(this.findCashboxName(item.company_cashbox_id));
      }
      
      // Проверяем все поля
      return standardFields.some(field => {
        if (field == null) return false;
        return field.toString().toLowerCase().includes(searchLower);
      });
    },
    saveOperation() {
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        this.axios
          .post(
            `/api/v1/create_cashbox_count?external=${self.internal_external}`,
            {
              counts: {
                sum: self.get_cash > 0 ? self.get_cash.toFixed(2) : self.give_cash.toFixed(2),
                operation: self.get_cash > 0 ? false : true,
                cash: self.cash_or_cashless ? false : true,
                entity: self.cash_or_cashless ? true : false,
                description: self.count_description,
                group: "Внутренние переводы",
                company_cashbox_id: self.selected_cashbox_in_operations && self.selected_cashbox_in_operations.id ? self.selected_cashbox_in_operations.id : { cash: 0, cashless: 0 },
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.showOperationPanel = false;
            this.applyOperationToBalances();

            this.counts.unshift(response.data);
            this.filtered_counts.unshift(response.data);
            this.get_cash = 0;
            this.give_cash = 0;
            this.cash_or_cashless = false;
            this.$notify(this.$t("counts.updated"), this.$t("counts.updated_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.kass_change"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    editCount(count) {
      if (this.isStaff) {
        this.selected_count_id = count.id;
        this.isLoadingEditCount = true;
        this.edited_created_at = null;
        this.original_created_at = null;
        this.editDialog = true;
        this.axios
          .get(`/api/v1/counts/${count.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.editedCount = response.data;
            this.original_created_at = response.data.created_at;
            this.edited_created_at = response.data.created_at ? new Date(response.data.created_at) : null;
            this.openEditCategory(this.editedCount);
            // this.selected_car = this.editedCount.car_id
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.update_count"));
          })
          .finally(() => (this.isLoadingEditCount = false, this.selected_count_id = null));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    translateCategory(category) {
      return translateCountCategory((key) => this.$t(key), category);
    },
    // Фильтры статьи и подкатегории поверх загруженного списка; без статьи ничего не трогает
    applyGroupFilters() {
      if (!this.selected_group) return;
      this.filtered_counts = filterBySubcategory(
        this.counts.filter((count) => count.group == this.selected_group),
        this.selected_subcategory_filter
      );
    },
    translateCountSource(source) {
      let source_text = "";
      switch (source) {
        case "Касса компании":
          source_text = this.$t("counts.company_counts");
          break;
        case "Внешний перевод":
          source_text = this.$t("counts_groups.external_transfers");
          break;
        case "stripe":
          source_text = this.$t("stripe_payment.title");
          break;
        case "yandex_pay":
          source_text = this.$t("yandex_pay.title");
          break;
        case "stripe_refund":
          source_text = this.$t("stripe_payment.title");
          break;
        case "yandex_pay_refund":
          source_text = this.$t("yandex_pay.title");
          break;
        default:
          source_text = source;
          break;
      }
      return source_text;
    },
    saveCount() {
      if (this.isStaff) {
        this.isLoadingSaveCount = true;
        let count = this.editedCount;
        let self = this;
        this.axios
          .patch(
            `/api/v1/counts/${count.id}`,
            {
              counts: {
                created_at: paymentDateForSave(this.original_created_at, this.edited_created_at),
                sum: count.sum.toFixed(2),
                operation: count.operation,
                cashless: count.cashless,
                description: count.description,
                group: this.editCategoryValue,
                car_id: this.selected_car ? this.selected_car.id : count.car_id,
                contractor_id: count.contractor_id,
                ...this.editSubcategoryPayload(),
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.editDialog = false;
            let foundIndex = this.counts.findIndex(
              (element) => element.id === count.id
            );

            let count_data = response.data;
            if (this.selected_car) {
              count_data.car_code = this.selected_car.code;
            }

            this.counts.splice(foundIndex, 1, count_data);
            let filtered_index = this.filtered_counts.findIndex(
              (element) => element.id === count.id
            );

            let filtered_count_data = response.data;
            if (this.selected_car) {
              filtered_count_data.car_code = this.selected_car.code;
            }

            this.filtered_counts.splice(filtered_index, 1, filtered_count_data);
            // Статья или подкатегория могли измениться: платёж обязан уйти из выборки чужой статьи/подкатегории
            this.applyGroupFilters();
            this.$notify(this.$t("counts.update_count_title"), this.$t("counts.update_count_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.update_count"));
          })
          .finally(() => (this.isLoadingSaveCount = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    processedCount(count) {
      if (this.isAdminPlus) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("counts.processed_payment_not_declined"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.yes"),
          cancelButtonText: this.$t("custom.no"),
        }).then((result) => {
          if (result) {
            this.isLoading = true;
            this.axios
              .post(
                `/api/v1/processed_count`,
                {
                  count_id: count.id,
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then((response) => {
                let foundIndex = this.counts.findIndex(
                  (element) => element.id === count.id
                )
                let filtered_index = this.filtered_counts.findIndex(
                  (element) => element.id === count.id
                )
                this.counts.splice(foundIndex, 1, response.data);
                this.filtered_counts.splice(filtered_index, 1, response.data);

                this.$notify(this.$t("counts.update_count_title"), this.$t("counts.update_count_text"), "success");
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.update_count"));
              })
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    cancelCount(count) {
      // Дублирует условие кнопки намеренно: кнопка — это UI, а это контракт метода.
      // У непроведённого платежа разворачивать нечего, он денег не двигал.
      if (!count.completed) {
        this.$notify(
          this.$t("errors.cancel_not_completed_title"),
          this.$t("errors.cancel_not_completed_text"),
          "warning",
          6000
        );
        return;
      }
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("counts.cancel_question_title"),
          text: this.$t("counts.cancel_question_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("counts.yes_cancel"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.selected_count_id = count.id;
            this.isLoadingcancelCount = true;
            this.axios
              .post(
                `/api/v1/cancel_count/${count.id}`,
                {
                  counts: {
                    cancel_count: true,
                  },
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then((response) => {
                // // Добавляем аннулирующий счет
                // this.counts.unshift(response.data.new_count)
                this.filtered_counts.unshift(response.data.new_count);

                // Ищем аннулированный счет и делаем его аннулированным
                let filtered_index = this.filtered_counts.findIndex((count) => {
                  count.id == response.data.old_count;
                });
                this.filtered_counts.splice(
                  filtered_index,
                  1,
                  response.data.old_count
                );
                this.$notify(this.$t("counts.canceled_success"), "", "success");
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.count_cancel"));
              })
              .finally(() => (this.isLoadingcancelCount = false, this.selected_count_id = null));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sumInBaseCurrency(sum, currency_id) {
      if (currency_id == this.base_currency_id) {
        return parseFloat(sum);
      }

      if (this.exchange_rates && this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find(rate => rate.target_currency_id == currency_id);

        if (exchange_rate && exchange_rate.rate) {
          let result = parseFloat((parseFloat(sum) / parseFloat(exchange_rate.rate)).toFixed(2));
          return result;
        } else {
          console.log('Rate not found for currency_id', currency_id);
          return 0;
        }
      } else {
        console.log('Rates not found for currency_id', currency_id);
        return 0;
      }
    },
    getCounts() {
      if (this.start_date && this.end_date) {
        // Проверка на максимальный период в 1 год
        const daysDifference = moment(this.end_date).diff(moment(this.start_date), 'days');
        if (daysDifference > 366) { // 366 дней для учета високосного года
          this.$notify(this.$t("analitics.period_too_long"), "", "warning", 5000);
          this.start_date = moment().subtract(1, "month").format("YYYY-MM-DD");
          this.end_date = moment().format("YYYY-MM-DD");
          this.start_date_format = moment().subtract(1, "month").format("DD-MM-YYYY");
          this.end_date_format = moment().format("DD-MM-YYYY");
          return;
        }
      } else if (this.start_date || this.end_date) {
        this.$notify(this.$t("errors.select_dates"), "", "warning", 5000);
        return;
      }
      
      this.isLoading = true;
      const url = this.start_date && this.end_date 
        ? `/api/v1/company_counts_v2?start_date=${this.start_date}&end_date=${this.end_date}`
        : `/api/v1/company_counts_v2`;
        
      this.axios
        .get(url, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          // FT-184: метки «через агента» платежей журнала едут в этом же ответе (agent_marks).
          agentMarkerLoader.prime(response.data.agent_marks);
          this.counts = [];
          this.filtered_counts = [];
          response.data.counts.data.forEach((count) => {
            this.counts.push(count.attributes);
            this.filtered_counts.push(count.attributes);
          });
          // Список перезагружен (смена дат): активные фильтры статьи и подкатегории — заново
          this.applyGroupFilters();
          this.workers = response.data.workers;
          this.$store.commit("setCompany", { company: response.data.company });

          this.contractors = [];
          response.data.contractors.data.forEach((contractor) => {
            this.contractors.push(contractor.attributes);
          });
          
          this.selected_cashbox_in_operations = this.active_company_cashboxes && this.active_company_cashboxes[0] 
            ? this.active_company_cashboxes[0] 
            : { cash: 0, cashless: 0 };
        })
        .catch((error) => {
          if (error.response?.status == 406) {
            this.$notify(error.response?.data.error, "", "warning", 5000);
          } else {
            this.setError(error, this.$t("errors.counts_load"));
          }
        })
        .finally(() => (this.isLoading = false));
    },
    updateСountCheck(id, state) {
      if (this.isAdminPlus) {
        this.isLoading = true;
        let self = this;
        let count = this.counts.find((element) => element.id === id);
        
        if (!count) {
          console.error('Count not found with id:', id);
          this.$notify(this.$t("errors.count_not_found"), "", "error");
          this.isLoading = false;
          return;
        }
        
        this.axios
          .patch(
            `/api/v1/counts/${count.id}`,
            {
              counts: {
                check: state,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let foundIndex = this.counts.findIndex(
              (element) => element.id === id
            );
            count.check = response.data.check;
            this.counts.splice(foundIndex, 1, count);

            this.$notify(this.$t("counts.state_updated"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.count_state"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    checkCountState(count) {
      let state = "";
      if (count.operation && count.sum < 0) {
        state = "red--text";
      }
      if (count.canceled) {
        state = `${state} text-decoration-line-through`;
      }
      return state;
    },
    totalSumByGroup(group) {
      const counts = this.filtered_counts.filter(count => count.group === group);
      const income = counts.filter(count => count.operation === true)
        .reduce((sum, count) => sum + parseFloat(count.sum), 0);
      const expense = counts.filter(count => count.operation === false)
        .reduce((sum, count) => sum + parseFloat(count.sum), 0);

      return (income - expense).toFixed(2);
    },
    totalSumRatedByGroup(group) {
      const counts = this.filtered_counts.filter(count => count.group === group);
      const income = counts.filter(count => count.operation === true)
        .reduce((sum, count) => sum + parseFloat(count.rated_sum || 0), 0);
      const expense = counts.filter(count => count.operation === false)
        .reduce((sum, count) => sum + parseFloat(count.rated_sum || 0), 0);

      return (income - expense).toFixed(2);
    },
    toXlsx() {
      if (this.isStaff) {
        let self = this;
        let data = [
          {
            sheets: "Payments",
            columns: [
              { label: "ID", value: "id" },
              { label: this.$t("custom.created_at"), value: "created_at" },
              { label: this.$t("custom.amount"), value: "sum" },
              { label: this.$t("custom.operation"), value: "operation" },
              { label: this.$t("counts.about"), value: "description" },
              { label: this.$t("money.terminal"), value: "cashless" },
              { label: this.$t("money.card_to_card"), value: "cash_card" },
              { label: this.$t("money.cash"), value: "cash" },
              { label: this.$t("money.from_entity"), value: "entity" },
              {
                label: this.$t("custom.creator"), value: (row) => {
                  return this.setWorker(row.user_id)
                }
              },
              {
                label: this.$t("custom.group"), value: (row) => {
                  return this.countCategoryLabel(row);
                }
              },
              {
                label: this.$t("companies.cashbox_name"), value: (row) => {
                  return this.findCashboxNameForExcel(row.company_cashbox_id);
                }
              },
              { label: this.$t("custom.car"), value: "car_code" },
              { label: this.$t("bookings.booking"), value: "booking_id" },
              { label: this.$t("debts.debt"), value: "debt_id" },
              { label: this.$t("employers.partner"), value: "investor_id" },
              { label: this.$t("counts.completed"), value: "completed" },
            ],
            content: this.filtered_counts && this.filtered_counts.length > 0 ? this.filtered_counts : this.counts,
          },
        ];
        let settings = {
          fileName: "payments", // Name of the resulting spreadsheet
          extraLength: 3, // A bigger number means that columns will be wider
          writeMode: "write", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
          writeOptions: {
            bookType: "xlsx",
            type: "array",
          }, // Style options from https://docs.sheetjs.com/docs/api/write-options
          RTL: false, // Display the columns from right-to-left (the default value is false)
        };
        let wbout = xlsx(data, settings);
        var blob_data = new Blob([new Uint8Array(wbout)], { type: "application/octet-stream" });
        if (!this.isNative) {
          saveAs(blob_data, 'payments.xlsx');
        } else {
          if (Filesystem.checkPermissions()) {
            const getBase64FromBlob = async (blob) => {
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                }
              });
            }
            getBase64FromBlob(blob_data).then(
              (base64) => {
                // save file
                async function writeFile() {
                  return await Filesystem.writeFile({
                    path: 'payments.xlsx',
                    data: base64,
                    directory: Directory.Documents,
                  });
                }
                let file_uri = null
                let writedFile = writeFile().then((getUriResult) => {
                  // share file opened file
                  let shareFile = async () => {
                    await Share.share({
                      title: 'Download document',
                      files: [getUriResult.uri],
                    }).catch((error) => {
                      console.log("shareFile", error)
                    });
                  };
                  let sharedFile = shareFile();
                }).catch((error) => {
                  console.log("shareFile", error)
                });
              }
            );
          } else {
            Filesystem.requestPermissions();
          }
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    setCar(id) {
      if (id != null) {
        if (this.cars.find((car) => car.id == id)) {
          return this.cars.find((car) => car.id == id).code;
        }
      } else {
        return "-";
      }
    },
    setWorker(id) {
      if (id != null) {
        if (this.workers.find((worker) => worker.id == id)) {
          return this.workers.find((worker) => worker.id == id).name;
        }
      } else {
        return "-";
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    findWorkersName(ids) {
      let names = [];
      ids.forEach((id) => {
        this.workers.forEach((worker) => {
          if (worker.id == id) {
            names.push(worker.name);
          }
        });
      });
      return names ? names.join(", ") : "";
    },
    findContractorName(id) {
      if (id != null) {
        if (this.contractors.find((contractor) => contractor.id == id)) {
          return this.contractors.find((contractor) => contractor.id == id)
            .short_name;
        }
      } else {
        return "-";
      }
    },
    findCashboxName(id) {
      if (id != null) {
        if (this.company_cashboxes.find((cashbox) => cashbox.id == id)) {
          return this.company_cashboxes.find((cashbox) => cashbox.id == id).name;
        }
      } else {
        return "-";
      }
    },
    findCashboxNameForExcel(id) {
      if (id != null) {
        if (this.company_cashboxes.find((cashbox) => cashbox.id == id)) {
          return this.company_cashboxes.find((cashbox) => cashbox.id == id).name;
        }
      } else {
        return this.$t("companies.cashbox_default");
      }
    },
    completedTooltipDialog(item) {
      if (item && item.completed_at && item.completed_by) {
        // Здесь стоял this.getWorkersNames() — след копипасты из BookingsListView.vue.
        // Метода тут нет (диалог не открывался вовсе), и он не нужен: workers страница
        // уже получила основной загрузкой, а этот метод пишет в workers_names/responsibles,
        // которых в CompanyCounts не существует.
        this.showProcessedInfoDialog = true;
        this.editedCount = item;
      } else {
        this.showProcessedInfoDialog = false;
      }
    },
    formatCompletedAt(date) {
      if (date == null) {
        return "-";
      }
      return moment.parseZone(date).format("lll");
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("lll");
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    checkSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
  },
};
</script>
